import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SnackbarPosition, SnackbarSeverity } from 'theSource/components';

export interface SnackbarState {
  severity: SnackbarSeverity;
  isOpen: boolean;
  message: string | JSX.Element;
  action?: JSX.Element;
  position?: SnackbarPosition;
  disableAutoHide?: boolean;
  zIndex?: number;
}

export type SnackbarPayload = Omit<SnackbarState, 'isOpen'>;

const initialState: SnackbarState = {
  severity: 'success',
  isOpen: false,
  message: '',
  position: 'aboveMenu',
  disableAutoHide: false,
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    addSnackbar: (state, { payload }: PayloadAction<SnackbarPayload>) => {
      if (state.isOpen) {
        dismissSnackbar();
      }
      return { disableAutoHide: false, ...payload, isOpen: true };
    },
    dismissSnackbar: (state) => {
      state.isOpen = false;
    },
  },
});

const { reducer, actions } = snackbarSlice;

// Actions
export const { addSnackbar, dismissSnackbar } = actions;

export const snackbarReducer = reducer;
